import { endOfDay } from "./endOfDay.js";
import { endOfMonth } from "./endOfMonth.js";
import { toDate } from "./toDate.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isLastDayOfMonth(date, options) {
  const _date = toDate(date, options?.in);
  return +endOfDay(_date, options) === +endOfMonth(_date, options);
}

/*                                */
export default isLastDayOfMonth;
